export default "__VITE_ASSET__7EoOadHR__"